import { render, staticRenderFns } from "./top_Services_sidebar.vue?vue&type=template&id=3b3375e0&scoped=true&"
import script from "./top_Services_sidebar.vue?vue&type=script&lang=js&"
export * from "./top_Services_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./top_Services_sidebar.vue?vue&type=style&index=0&id=3b3375e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3375e0",
  null
  
)

export default component.exports